import { Brick, registerBrick, ErrorFlow } from 'olympe';
import { getLogger } from '@olympeio/core';
import * as _ from 'lodash';
import { getAsJson, iterateInObject } from '../../helper';

export default class MapKeys extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} source
     * @param {*} iteratee
     * @param {function(*)} setResult
     * @param {function(*)} setErrorFlow
     */
    async update($, [source, iteratee], [setResult, setErrorFlow]) {
        const logger = getLogger('Map Keys');

        // Guards
        if (!(iteratee instanceof Brick)) {
            logger.error('Provided iteratee input is not a Brick');
            return;
        }

        const { json, error } = getAsJson(source);

        if (!error) {
            const changedKeys = await iterateInObject($, json, iteratee);

            let index = 0;
            const result = _.mapKeys(json, (value, key) => changedKeys[index++]);
            setResult(result);
        } else {
            logger.error(error.message);
            setErrorFlow(ErrorFlow.create(error.message, error.code));
        }
    }
}

registerBrick('017ff8f5875fdc5ca1a8', MapKeys);